import { render, staticRenderFns } from "./addPassenger.vue?vue&type=template&id=76196356&"
import script from "./addPassenger.vue?vue&type=script&lang=js&"
export * from "./addPassenger.vue?vue&type=script&lang=js&"
import style0 from "./addPassenger.vue?vue&type=style&index=0&id=76196356&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports